import { render, staticRenderFns } from "./StorageData.vue?vue&type=template&id=1e287e10&scoped=true&"
import script from "./StorageData.vue?vue&type=script&lang=js&"
export * from "./StorageData.vue?vue&type=script&lang=js&"
import style0 from "./StorageData.vue?vue&type=style&index=0&id=1e287e10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e287e10",
  null
  
)

export default component.exports